import { render, staticRenderFns } from "./faculty.vue?vue&type=template&id=1c7e1a22&scoped=true"
import script from "./faculty.vue?vue&type=script&lang=js"
export * from "./faculty.vue?vue&type=script&lang=js"
import style0 from "./faculty.vue?vue&type=style&index=0&id=1c7e1a22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7e1a22",
  null
  
)

export default component.exports